// prettier-ignore
export const tagColors = ['framboise', 'mandarine', 'taupe', 'miel', 'limoncello', 'amande', 'kaki', 'aloe-vera', 'étang', 'bleu-ciel', 'gris-bleu', 'lavande', 'violine', 'lila', 'cassis', 'barbapapa', 'gris'] as const;
// prettier-ignore
export const intensities = ['supershy', 'quiet', 'moderate', 'intense'] as const;
type TagColor = (typeof tagColors)[number];
type Intensity = (typeof intensities)[number];
export type TagColorWithIntensity = `${TagColor}-${Intensity}`;

// prettier-ignore
export const tagBackgroundColors: Record<TagColorWithIntensity, string> = {
  'framboise-supershy'   : '#FFDEDE',
  'framboise-quiet'      : '#FFBDBD',
  'framboise-moderate'   : '#FF9B9A',
  'framboise-intense'    : '#FF797A',

  'mandarine-supershy'   : '#FFE8DB',
  'mandarine-quiet'      : '#FFD2B8',
  'mandarine-moderate'   : '#FFBC96',
  'mandarine-intense'    : '#FFA573',

  'taupe-supershy'       : '#F5ECE9',
  'taupe-quiet'          : '#E9D9D3',
  'taupe-moderate'       : '#DEC7BD',
  'taupe-intense'        : '#D3B4A7',

  'miel-supershy'        : '#FEF1DD',
  'miel-quiet'           : '#FDE3BD',
  'miel-moderate'        : '#FED49B',
  'miel-intense'         : '#FCC779',

  'limoncello-supershy'  : '#FFF8D9',
  'limoncello-quiet'     : '#FFF0B3',
  'limoncello-moderate'  : '#FEEA8C',
  'limoncello-intense'   : '#FFE366',

  'amande-supershy'      : '#F6FBE5',
  'amande-quiet'         : '#EDF7CA',
  'amande-moderate'      : '#E3F2B0',
  'amande-intense'       : '#D8EF95',

  'kaki-supershy'        : '#E7F1E7',
  'kaki-quiet'           : '#D1E3D0',
  'kaki-moderate'        : '#B8D6B8',
  'kaki-intense'         : '#A1C8A1',

  'aloe-vera-supershy'   : '#E0F4EA',
  'aloe-vera-quiet'      : '#C1E8D7',
  'aloe-vera-moderate'   : '#A1DCC3',
  'aloe-vera-intense'    : '#81D0B0',

  'étang-supershy'       : '#EBF4F5',
  'étang-quiet'          : '#D8EAEB',
  'étang-moderate'       : '#C3DFE2',
  'étang-intense'        : '#B0D5D9',

  'bleu-ciel-supershy'   : '#E6F4FB',
  'bleu-ciel-quiet'      : '#CEE9F7',
  'bleu-ciel-moderate'   : '#B5DEF3',
  'bleu-ciel-intense'    : '#9AD3EF',

  'gris-bleu-supershy'   : '#EFF1FA',
  'gris-bleu-quiet'      : '#DEE4F4',
  'gris-bleu-moderate'   : '#CDD6EF',
  'gris-bleu-intense'    : '#BDC9EA',

  'lavande-supershy'     : '#E5E9FC',
  'lavande-quiet'        : '#CAD4F9',
  'lavande-moderate'     : '#AEBFF7',
  'lavande-intense'      : '#91ABF1',

  'violine-supershy'     : '#ECE5FE',
  'violine-quiet'        : '#D8CCFD',
  'violine-moderate'     : '#C4B3FB',
  'violine-intense'      : '#AE9AF9',

  'lila-supershy'        : '#F9E9F9',
  'lila-quiet'           : '#F1D3F3',
  'lila-moderate'        : '#EABDED',
  'lila-intense'         : '#E2A7E7',

  'cassis-supershy'      : '#F4E9F2',
  'cassis-quiet'         : '#E9D3E5',
  'cassis-moderate'      : '#DEBDD8',
  'cassis-intense'       : '#D3A7CB',

  'barbapapa-supershy'   : '#FFECEF',
  'barbapapa-quiet'      : '#FFD9E0',
  'barbapapa-moderate'   : '#FFC6D1',
  'barbapapa-intense'    : '#FFB3C2',

  'gris-supershy'        : '#FFFFFF',
  'gris-quiet'           : '#E1E1E5',
  'gris-moderate'        : '#C4C4CC',
  'gris-intense'         : '#A7A7B4',
};

export const tagBackgroundColorNames = Object.keys(
  tagBackgroundColors,
) as TagColorWithIntensity[];

// prettier-ignore
export const tagTextColor: Record<TagColor, string> = {
  'framboise'            : '#710001',
  'mandarine'            : '#6F2800',
  'taupe'                : '#4C3126',
  'miel'                 : '#6D4202',
  'limoncello'           : '#6B5700',
  'amande'               : '#4F650F',
  'kaki'                 : '#284428',
  'aloe-vera'            : '#1B4A37',
  'étang'                : '#264C50',
  'bleu-ciel'            : '#104A66',
  'gris-bleu'            : '#1F3060',
  'lavande'              : '#0D2567',
  'violine'              : '#1D0772',
  'lila'                 : '#581A5E',
  'cassis'               : '#4C2645',
  'barbapapa'            : '#70041A',
  'gris'                 : '#303038',
};

// prettier-ignore
export const tagTextColorForWhiteBg: Record<TagColor, string> = {
  'framboise'            : '#D23D3E',
  'mandarine'            : '#BB5B25',
  'taupe'                : '#906A5A',
  'miel'                 : '#9C6C23',
  'limoncello'           : '#8A730B',
  'amande'               : '#637A22',
  'kaki'                 : '#577E57',
  'aloe-vera'            : '#217D58',
  'étang'                : '#308089',
  'bleu-ciel'            : '#387A9A',
  'gris-bleu'            : '#6274A3',
  'lavande'              : '#4160B4',
  'violine'              : '#7B69BC',
  'lila'                 : '#9E56A4',
  'cassis'               : '#8E6687',
  'barbapapa'            : '#B5576A',
  'gris'                 : '#6E6E7B',
};

// prettier-ignore
export const tagColorToTextColor: Record<TagColorWithIntensity, TagColor> = {
  'framboise-supershy'   : 'framboise',
  'framboise-quiet'      : 'framboise',
  'framboise-moderate'   : 'framboise',
  'framboise-intense'    : 'framboise',
  'mandarine-supershy'   : 'mandarine',
  'mandarine-quiet'      : 'mandarine',
  'mandarine-moderate'   : 'mandarine',
  'mandarine-intense'    : 'mandarine',
  'taupe-supershy'       : 'taupe',
  'taupe-quiet'          : 'taupe',
  'taupe-moderate'       : 'taupe',
  'taupe-intense'        : 'taupe',
  'miel-supershy'        : 'miel',
  'miel-quiet'           : 'miel',
  'miel-moderate'        : 'miel',
  'miel-intense'         : 'miel',
  'limoncello-supershy'  : 'limoncello',
  'limoncello-quiet'     : 'limoncello',
  'limoncello-moderate'  : 'limoncello',
  'limoncello-intense'   : 'limoncello',
  'amande-supershy'      : 'amande',
  'amande-quiet'         : 'amande',
  'amande-moderate'      : 'amande',
  'amande-intense'       : 'amande',
  'kaki-supershy'        : 'kaki',
  'kaki-quiet'           : 'kaki',
  'kaki-moderate'        : 'kaki',
  'kaki-intense'         : 'kaki',
  'aloe-vera-supershy'   : 'aloe-vera',
  'aloe-vera-quiet'      : 'aloe-vera',
  'aloe-vera-moderate'   : 'aloe-vera',
  'aloe-vera-intense'    : 'aloe-vera',
  'étang-supershy'       : 'étang',
  'étang-quiet'          : 'étang',
  'étang-moderate'       : 'étang',
  'étang-intense'        : 'étang',
  'bleu-ciel-supershy'   : 'bleu-ciel',
  'bleu-ciel-quiet'      : 'bleu-ciel',
  'bleu-ciel-moderate'   : 'bleu-ciel',
  'bleu-ciel-intense'    : 'bleu-ciel',
  'gris-bleu-supershy'   : 'gris-bleu',
  'gris-bleu-quiet'      : 'gris-bleu',
  'gris-bleu-moderate'   : 'gris-bleu',
  'gris-bleu-intense'    : 'gris-bleu',
  'lavande-supershy'     : 'lavande',
  'lavande-quiet'        : 'lavande',
  'lavande-moderate'     : 'lavande',
  'lavande-intense'      : 'lavande',
  'violine-supershy'     : 'violine',
  'violine-quiet'        : 'violine',
  'violine-moderate'     : 'violine',
  'violine-intense'      : 'violine',
  'lila-supershy'        : 'lila',
  'lila-quiet'           : 'lila',
  'lila-moderate'        : 'lila',
  'lila-intense'         : 'lila',
  'cassis-supershy'      : 'cassis',
  'cassis-quiet'         : 'cassis',
  'cassis-moderate'      : 'cassis',
  'cassis-intense'       : 'cassis',
  'barbapapa-supershy'   : 'barbapapa',
  'barbapapa-quiet'      : 'barbapapa',
  'barbapapa-moderate'   : 'barbapapa',
  'barbapapa-intense'    : 'barbapapa',
  'gris-supershy'        : 'gris',
  'gris-quiet'           : 'gris',
  'gris-moderate'        : 'gris',
  'gris-intense'         : 'gris',
};
